import {InputTitleNormal} from '../../common/TitleStyle'
import styled from '@emotion/styled'
import {Alert, AlertTitle, Box} from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

const StyledAlert = styled(Alert)(({theme}) => ({
  fontSize: theme.typography.body1.fontSize,
  marginTop: theme.spacing(2),
  backgroundColor: theme.palette.warning.light,
  '& .MuiAlert-action': {
    alignItems: 'center',
    paddingTop: theme.spacing(0.5)
  }
}))

const StyledAlertTitle = styled(AlertTitle)(({theme}) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(1),
  color: theme.palette.hpAccentBlack
}))

const CustomInfoIcon = styled(InfoOutlinedIcon)(({theme}) => ({
  color: theme.palette.hpAccentOrange,
  marginTop: theme.spacing(2)
}))

const UserFeedbackSubTitle = styled(InputTitleNormal)(({theme}) => ({
  marginTop: theme.spacing(1),
  marginLeft: theme.spacing(1),
  color: theme.palette.grey[600]
}))

const UserFeedbackNote = styled(InputTitleNormal)(({theme}) => ({
  marginTop: theme.spacing(3),
  marginLeft: theme.spacing(1),
  color: theme.palette.hpBlack,
  backgroundColor: theme.palette.hpPrimaryLightest,
  padding: theme.spacing(0.5)
}))

const UserFeedbackContainer = styled(Box)(({theme}) => ({
  marginTop: theme.spacing(5)
}))

export {UserFeedbackSubTitle, UserFeedbackNote, CustomInfoIcon, StyledAlert, StyledAlertTitle, UserFeedbackContainer}
